export const CATEGORIES = [
  {
    id: "EntradasId",
    label: "Entradas",
  },
  {
    id: "HamburguesasId",
    label: "Hamburguesas",
  },
  {
    id: "MilanesasId",
    label: "Milanesas",
  },
];
